import { render } from "./GiftPackDialog.vue?vue&type=template&id=2e8d4e3a&scoped=true"
import script from "./GiftPackDialog.vue?vue&type=script&lang=js"
export * from "./GiftPackDialog.vue?vue&type=script&lang=js"

import "./GiftPackDialog.vue?vue&type=style&index=0&id=2e8d4e3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8d4e3a"]])

export default __exports__